var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCookComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66083",
    "data-name": "Group 66083",
    transform: "translate(-45 -221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66082",
    "data-name": "Group 66082",
    transform: "translate(1.285 1.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3014",
    "data-name": "Ellipse 3014",
    transform: "translate(48.715 224.715)",
    fill: "rgba(255,255,255,0)",
    stroke: "#fff",
    strokeWidth: 5,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3013",
    "data-name": "Ellipse 3013",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(48.715 224.715)",
    fill: "rgba(255,255,255,0)",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66081",
    "data-name": "Group 66081",
    transform: "translate(1.283 0.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63861",
    "data-name": "Path 63861",
    d: "M2677.391-15182.705l1.983,2.15,5.7-5.021",
    transform: "translate(-2623 15418.001)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookComplete);
export default __webpack_public_path__ + "static/media/cook-complete.1ae2851378bddb4a74e4f6ec25f8640c.svg";
export { ForwardRef as ReactComponent };